export const currency = 'EUR'
